const e = {
  thousand: 1e3,
  million: 1e6,
  billion: 1e9
}, a = (t, n) => new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t), i = (t, n = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t / e.thousand)}K`, m = (t, n = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t / e.million)}M`, u = (t, n = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t / e.billion)}B`, c = (t, n) => {
  const o = Math.abs(t);
  return o >= e.billion ? u : o >= e.million ? m : n && o >= e.thousand ? i : a;
}, f = ({
  number: t,
  maximumFractionDigits: n,
  shorten: o = !0,
  formatThousands: l = !1
}) => {
  const r = Math.abs(t), s = o ? c(r, l) : a;
  return `${t < 0 ? "-" : ""}${s(r, n)}`;
};
export {
  e as MAGNITUDES,
  u as formatBillions,
  a as formatDefault,
  m as formatMillions,
  i as formatThousands,
  f as numberFormat
};
//# sourceMappingURL=index.es2324.js.map
